// extracted by mini-css-extract-plugin
export default {"fullWidth":"Accordion_fullWidth__4DEY2","header":"Accordion_header__Hf-Xn"};